module.exports = __webpack_public_path__ + "static/media/travel-1.372ef670.png";